import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type PayLinkState = {
  isEnabled: boolean
  togglePayLink: () => void
  setPayLink: (enabled: boolean) => void
}

export const usePayLinkStore = create<PayLinkState>()(
  persist(
    (set) => ({
      isEnabled: false, // Default state is disabled
      togglePayLink: () => set((state) => ({ isEnabled: !state.isEnabled })),
      setPayLink: (enabled: boolean) => set({ isEnabled: enabled }),
    }),
    {
      name: 'paylink-storage', // unique name for localStorage key
    }
  )
)